import $ from 'jquery';

function initFAQ() {
    $('.questions-block').each(function () {
        let $block = $(this);
        let $items = $block.find('.accordion-item');
        $items.each(function () {
            let $item = $(this);
            let $header = $item.find('.accordion-item__header');
            let $content = $item.find('.accordion-item__content');
            $header.on('click', function () {
                if ($item.hasClass('active')) {
                    $item.removeClass('active');
                    $content.slideUp();
                    return;
                } else {
                    $items.removeClass('active');
                    $items.find('.accordion-item__content').slideUp();
                    $item.addClass('active');
                    $content.slideDown();
                }
            });
        });
    });
}

export { initFAQ };